// ══════════════════════════════════════════════════════════════
// District88 — Global Search Service
// Searches across profiles, listings, and posts
// ══════════════════════════════════════════════════════════════

import { supabase } from '../lib/supabase';
import type { Profile, Listing, Post } from '../types/database';

export interface SearchResults {
  profiles: Profile[];
  listings: (Listing & { seller: Profile })[];
  posts: (Post & { author: Profile })[];
}

export async function globalSearch(query: string, limit = 10): Promise<SearchResults> {
  if (!query || query.length < 2) {
    return { profiles: [], listings: [], posts: [] };
  }

  const [profilesRes, listingsRes, postsRes] = await Promise.all([
    supabase
      .from('profiles')
      .select('*')
      .or(`username.ilike.%${query}%,display_name.ilike.%${query}%`)
      .limit(limit),
    supabase
      .from('listings')
      .select('*, seller:profiles!seller_id(*)')
      .eq('status', 'active')
      .or(`title.ilike.%${query}%,description.ilike.%${query}%,brand.ilike.%${query}%`)
      .order('created_at', { ascending: false })
      .limit(limit),
    supabase
      .from('posts')
      .select('*, author:profiles!author_id(*)')
      .ilike('content', `%${query}%`)
      .order('created_at', { ascending: false })
      .limit(limit),
  ]);

  return {
    profiles: (profilesRes.data || []) as Profile[],
    listings: (listingsRes.data || []) as (Listing & { seller: Profile })[],
    posts: (postsRes.data || []) as (Post & { author: Profile })[],
  };
}
